module.exports = __webpack_public_path__ + "img/img-oque-fazemos-01.6033680a.png";